import { TAddress, TAddressType } from 'models';

export const getParentsAddedTypes = (addresses: TAddress[], exclude?: TAddressType) => addresses
  .map((item) => item.props.type[0])
  .filter(i => i !== exclude);
